function TimesheetEmptyIcon() {
  return (
    <svg width="87" height="87" viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7680_122634)">
        <path
          d="M39.5443 86.3273H39.4399C28.4437 85.3015 18.266 80.0764 11.0236 71.7387C3.78127 63.401 0.0316281 52.5923 
0.554524 41.5607C1.07742 30.5291 5.83261 20.1236 13.8311 12.5083C21.8297 4.893 32.4559 0.654 43.4999 
0.672916C49.1788 0.663039 54.8026 1.787 60.0415 3.97892C62.5724 5.04103 64.9962 6.34227 67.2799 
7.86492L66.3055 3.16692C66.2743 3.01458 66.2734 2.85759 66.3028 2.7049C66.3322 2.55221 66.3915 
2.40682 66.4771 2.27702C66.6501 2.01488 66.9201 1.83218 67.2277 1.76912C67.5354 1.70605 67.8555 
1.76778 68.1176 1.94072C68.3797 2.11367 68.5624 2.38366 68.6255 2.69132L70.2495 10.4981C70.2806 
10.6493 70.2812 10.8051 70.2513 10.9564C70.2215 11.1078 70.1617 11.2517 70.0755 11.3797C69.9909 
11.5079 69.8818 11.6179 69.7543 11.7035C69.6269 11.7892 69.4837 11.8486 69.3331 11.8785L62.1991 
13.2357C62.0468 13.2639 61.8904 13.2618 61.7389 13.2295C61.5873 13.1973 61.4436 13.1355 61.316 
13.0477C61.1884 12.9599 61.0793 12.8478 60.9949 12.7179C60.9106 12.5879 60.8527 12.4426 60.8245 
12.2903C60.7963 12.138 60.7984 11.9816 60.8307 11.8301C60.8629 11.6785 60.9247 11.5349 61.0125 
11.4072C61.1003 11.2796 61.2124 11.1705 61.3423 11.0861C61.4723 11.0018 61.6176 10.9439 61.7699 
10.9157L66.4099 10.0225C64.1287 8.48254 61.7001 7.17305 59.1599 6.11332C53.7681 3.87519 47.957 
2.82618 42.1229 3.03783C36.2888 3.24947 30.569 4.71679 25.3535 7.33972C20.138 9.96265 15.5495 
13.6795 11.9009 18.2368C8.25228 22.7941 5.62941 28.0846 4.21113 33.7476C2.79285 39.4106 2.61252 
45.3129 3.68244 51.0519C4.75236 56.791 7.04736 62.2318 10.4109 67.0033C13.7745 71.7748 18.1276 
75.7649 23.1732 78.7013C28.2189 81.6377 33.8384 83.4515 39.6487 84.0189C39.9564 84.0328 40.2459 
84.1683 40.4537 84.3956C40.6614 84.6229 40.7703 84.9235 40.7565 85.2311C40.7427 85.5388 40.6072 
85.8283 40.3798 86.0361C40.1525 86.2438 39.852 86.3528 39.5443 86.3389V86.3273ZM48.2327 
86.2461C47.9459 86.2479 47.6687 86.1433 47.4545 85.9527C47.2402 85.762 47.1042 85.4987 47.0727 
85.2137C47.0401 84.9094 47.1291 84.6045 47.3203 84.3655C47.5115 84.1265 47.7894 83.9727 48.0935 
83.9377C50.8041 83.6255 53.4774 83.0465 56.0743 82.2093C56.222 82.1507 56.3801 82.1231 56.5389 
82.1282C56.6977 82.1332 56.8538 82.1709 56.9974 82.2387C57.1411 82.3066 57.2692 82.4032 57.374 
82.5226C57.4788 82.6421 57.5579 82.7817 57.6065 82.933C57.655 83.0843 57.672 83.2439 57.6563 
83.402C57.6407 83.5601 57.5927 83.7133 57.5154 83.8521C57.4381 83.9909 57.3331 84.1123 57.2069 
84.2088C57.0807 84.3054 56.9361 84.375 56.7819 84.4133C54.0453 85.3102 51.223 85.9205 48.3603 
86.2345L48.2327 86.2461ZM62.0251 82.1977C61.8077 82.1982 61.5945 82.1375 61.41 82.0226C61.2254 
81.9078 61.0768 81.7434 60.9811 81.5481C60.8568 81.2805 60.8393 80.9755 60.9319 80.6954C61.0246 
80.4152 61.2206 80.1809 61.4799 80.0401C63.8224 78.8747 66.0482 77.488 68.1267 75.8989C68.3682 
75.7036 68.6774 75.6121 68.9863 75.6448C69.2952 75.6774 69.5785 75.8314 69.7739 76.0729C69.9693 
76.3144 70.0607 76.6236 70.028 76.9326C69.9954 77.2415 69.8414 77.5248 69.5999 77.7201C67.4052 
79.4041 65.0508 80.8688 62.5703 82.0933C62.3997 82.1717 62.2126 82.2076 62.0251 82.1977ZM73.4859 
73.8225C73.1832 73.8243 72.8918 73.7078 72.6739 73.4977C72.5652 73.3899 72.4789 73.2616 72.42 
73.1202C72.3611 72.9789 72.3308 72.8272 72.3308 72.6741C72.3308 72.521 72.3611 72.3694 72.42 
72.228C72.4789 72.0866 72.5652 71.9584 72.6739 71.8505C74.5104 69.9513 76.1612 67.8809 77.6039 
65.6677C77.6869 65.5398 77.7943 65.4294 77.92 65.3429C78.0457 65.2565 78.1871 65.1956 78.3363 
65.1639C78.4855 65.1321 78.6395 65.13 78.7895 65.1578C78.9395 65.1855 79.0825 65.2425 79.2105 
65.3255C79.3385 65.4085 79.4488 65.516 79.5353 65.6416C79.6217 65.7673 79.6826 65.9088 79.7143 
66.0579C79.7461 66.2071 79.7482 66.3611 79.7205 66.5111C79.6927 66.6611 79.6357 66.8042 79.5527 
66.9321C78.027 69.2756 76.2789 71.4666 74.3327 73.4745C74.2225 73.5869 74.0907 73.6758 73.9451 
73.7356C73.7995 73.7954 73.6433 73.825 73.4859 73.8225ZM81.5131 62.0601C81.349 62.0594 81.1869 
62.0238 81.0375 61.9557C80.7579 61.8291 80.5399 61.5969 80.4312 61.3099C80.3225 61.0229 80.332 
60.7046 80.4575 60.4245C81.5382 58.0482 82.3889 55.5738 82.9979 53.0353C83.0687 52.7277 83.2587 
52.4607 83.5263 52.2932C83.7939 52.1257 84.117 52.0714 84.4247 52.1421C84.7323 52.2129 84.9993 
52.403 85.1668 52.6705C85.3343 52.9381 85.3887 53.2613 85.3179 53.5689C84.6761 56.256 83.7748 
58.8745 82.6267 61.3873C82.5296 61.5979 82.3716 61.7746 82.1731 61.8945C81.9746 62.0145 81.7447 
62.0721 81.5131 62.0601ZM67.9295 59.7401C67.744 59.7409 67.561 59.6971 67.3959 59.6125L40.5071 
45.8085C40.3158 45.7121 40.1549 45.5646 40.0423 45.3824C39.9297 45.2002 39.8698 44.9903 39.8691 
44.7761V15.4977C39.8691 15.1901 39.9913 14.895 40.2089 14.6775C40.4264 14.4599 40.7215 14.3377 
41.0291 14.3377C41.3368 14.3377 41.6318 14.4599 41.8493 14.6775C42.0669 14.895 42.1891 15.1901 
42.1891 15.4977V44.0801L68.4399 57.5245C68.6651 57.6459 68.8439 57.8383 68.9484 58.0718C69.0529 
58.3054 69.0773 58.5669 69.0177 58.8157C68.9582 59.0645 68.818 59.2866 68.6191 59.4475C68.4202 
59.6084 68.1737 59.6991 67.9179 59.7053L67.9295 59.7401ZM85.0859 48.6041H84.9815C84.6754 48.5747 
84.3936 48.4251 84.1978 48.188C84.002 47.9509 83.9084 47.6458 83.9375 47.3397C84.0419 46.1217 
84.0999 44.8689 84.0999 43.6277C84.1004 42.1319 84.019 40.6371 83.8563 39.1501C83.8225 38.8425 
83.9122 38.534 84.1058 38.2925C84.2994 38.051 84.581 37.8964 84.8887 37.8625C85.1964 37.8287 
85.5048 37.9184 85.7463 38.112C85.9878 38.3057 86.1425 38.5873 86.1763 38.8949C86.3485 40.4666 
86.4337 42.0466 86.4315 43.6277C86.4315 44.9385 86.4315 46.2609 86.2575 47.5485C86.2231 47.8335 
86.0843 48.0955 85.8679 48.2841C85.6515 48.4726 85.3729 48.5743 85.0859 48.5693V48.6041ZM83.9259 
34.2201C83.6625 34.2285 83.4041 34.1468 83.1932 33.9887C82.9824 33.8306 82.8317 33.6053 82.7659 
33.3501C82.1043 30.7879 81.1912 28.2972 80.0399 25.9145C79.9686 25.7768 79.9256 25.6263 79.9134 
25.4717C79.9013 25.3171 79.9202 25.1617 79.9692 25.0146C80.0181 24.8674 80.0961 24.7316 80.1984 
24.6152C80.3008 24.4987 80.4254 24.4039 80.565 24.3364C80.7046 24.269 80.8564 24.2302 81.0112 
24.2223C81.1661 24.2145 81.3209 24.2378 81.4666 24.2908C81.6123 24.3438 81.7459 24.4255 81.8595 
24.5311C81.9731 24.6366 82.0643 24.7639 82.1279 24.9053C83.3382 27.4172 84.3054 30.0392 85.0163 
32.7353C85.0546 32.8831 85.0635 33.037 85.0422 33.1882C85.021 33.3393 84.9701 33.4848 84.8925 
33.6163C84.8149 33.7478 84.7121 33.8627 84.59 33.9543C84.468 34.046 84.329 34.1127 84.1811 
34.1505C84.0937 34.1717 84.0042 34.1834 83.9143 34.1853L83.9259 34.2201Z"
          fill="#023B58"
        />
      </g>
      <defs>
        <clipPath id="clip0_7680_122634">
          <rect width="87" height="87" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TimesheetEmptyIcon;
